import React from "react";
import { Typography } from "@mui/material";

const TicketTypeName = ({ name, handleTicketTypeNameClicked }) => {
  return (
    <Typography
      color={Boolean(handleTicketTypeNameClicked) ? "primary" : ""}
      sx={{
        cursor: Boolean(handleTicketTypeNameClicked) ? "pointer" : "default",
      }}
      onClick={() => {
        if (handleTicketTypeNameClicked) {
          handleTicketTypeNameClicked();
        }
      }}
    >
      {name}
    </Typography>
  );
};

export default TicketTypeName;
